import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPrayingHands, FaSeedling, FaHeart } from "react-icons/fa";


const InfoHighlights = () => {
    const navigate = useNavigate();
  return (
    <section className="bg-[#f5f9f8] py-20 px-6">
      <div className="text-center mb-12" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-gray-800 uppercase tracking-wide">
          Welcome to Sahaja Yoga
        </h2>
        <p className="mt-2 text-gray-600 max-w-2xl mx-auto text-lg">
          Discover the power of inner peace, balance, and spiritual transformation.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {/* Card 1 */}
        <div
          className="bg-white rounded-2xl shadow-md p-8 text-center transition hover:shadow-xl"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          <div className="flex items-center justify-center mb-4">
            <div className="w-14 h-14 bg-green-100 text-green-700 flex items-center justify-center text-3xl rounded-full shadow">
              <FaPrayingHands />
            </div>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Everyone Needs Meditation</h3>
          <p className="text-gray-600">
            Humanity is going through challenges. Meditation helps us{" "}
            <span className="text-green-700 font-medium">relieve stress</span>,
            balance our emotions, and connect deeply with our inner self every day.
          </p>
        </div>

        {/* Card 2 */}
        <div
          className="bg-white rounded-2xl shadow-md p-8 text-center transition hover:shadow-xl"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div className="flex items-center justify-center mb-4">
            <div className="w-14 h-14 bg-indigo-100 text-indigo-700 flex items-center justify-center text-3xl rounded-full shadow">
              <FaSeedling />
            </div>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Sahaja Yoga is Transformational</h3>
          <p className="text-gray-600">
            Sahaja Yoga starts with a spontaneous experience called{" "}
            <span className="text-green-700 font-medium">Self-Realization</span>,
            opening a new dimension of awareness and connection with truth.
          </p>
        </div>

        {/* Card 3 */}
        <div
          className="bg-white rounded-2xl shadow-md p-8 text-center transition hover:shadow-xl"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <div className="flex items-center justify-center mb-4">
            <div className="w-14 h-14 bg-rose-100 text-rose-700 flex items-center justify-center text-3xl rounded-full shadow">
              <FaHeart />
            </div>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Unlock The Benefits Today</h3>
          <p className="text-gray-600">
            Meditation improves focus, memory, and spiritual growth. Start today with
            a pure heart and
            <span className="text-green-700 font-medium"> discover your journey</span>.
          </p>
        </div>
      </div>

      <div className="mt-12 text-center" data-aos="fade-up">
        <button
           onClick={() => navigate("/chakras")}
          className="bg-green-700 text-white font-medium px-8 py-3 rounded-full hover:bg-green-800 transition"
        >
          Learn More
        </button>
      </div>
    </section>
  );
};

export default InfoHighlights;
